import {useState, useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {getAuthLink} from '../http/Api';
import {routes} from '../constants/routes';
import {setToken, getToken} from '../utils/Token';

export const useAuth = () => {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(location.search);
  const code = urlParams.get('code');

  useEffect(() => {
    const getLink = async () => {
      try {
        const response = await getAuthLink(code);

        console.log('response', response);
        setToken(response?.data?.token);
        navigate(routes.chooseServer);
      } catch (error) {
        console.log('error', error);
        navigate(routes.chooseServer);
      } finally {
        setIsLoading(false);
      }
    };

    getLink();
  }, [code]);

  return {isLoading};
};

export const useLogout = () => {
  const navigate = useNavigate();

  const logout = () => {
    setToken();
    navigate(routes.home);
  };

  return {logout};
};

export const useUser = () => {
  const token = getToken();

  return {
    isAuth: Boolean(token),
    // isAuth: false,
  };
};
